(function () {
  'use strict';

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  async function subscribe(accountId, listId, email) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(accountId);
    var res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Spyr landing page',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      })
    });
    // Klaviyo returns 202 Accepted on success
    if (res.status !== 202 && !res.ok) {
      var body = null;
      try { body = await res.json(); } catch (_) {}
      var msg = body && body.errors && body.errors[0] && body.errors[0].detail;
      throw new Error(msg || ('Klaviyo subscription failed: ' + res.status));
    }
  }

  document.addEventListener('submit', async function (e) {
    var form = e.target.closest && e.target.closest('[data-signup-form]');
    if (!form) return;
    e.preventDefault();

    var section = form.closest('.spyr-signup');
    if (!section) return;
    var emailInput = form.querySelector('[name="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var btnLabel = form.querySelector('.spyr-signup__submit-label');
    var errorEl = section.querySelector('[data-signup-error]');
    var successEl = section.querySelector('[data-signup-success]');

    var email = (emailInput.value || '').trim();
    if (!isValidEmail(email)) {
      emailInput.focus();
      return;
    }

    var accountId = section.getAttribute('data-klaviyo-account');
    var listId = section.getAttribute('data-klaviyo-list');
    if (!accountId || !listId) {
      console.error('[signup] missing Klaviyo account or list ID');
      return;
    }

    if (errorEl) errorEl.hidden = true;
    btn.disabled = true;
    var originalLabel = btnLabel ? btnLabel.textContent : null;
    if (btnLabel) btnLabel.textContent = 'Sending';

    try {
      await subscribe(accountId, listId, email);
      // Optimistic success — Klaviyo's 202 means accepted; double opt-in (if enabled) goes from there
      section.classList.add('is-success');
      if (successEl) successEl.hidden = false;
    } catch (err) {
      console.error('[signup]', err);
      if (errorEl) errorEl.hidden = false;
      btn.disabled = false;
      if (btnLabel && originalLabel) btnLabel.textContent = originalLabel;
    }
  });
})();
